<template>
    <div>
        <v-row>
            <v-col class="py-5" cols="6" sm="4" v-for="(n, index) in contents" :key="index + 'former'">
                <v-img
                max-height="185" 
                contain
                :src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                class="transparent lighten-2 mb-3"
                >
                    <template v-slot:placeholder>
                    <v-layout
                        fill-height
                        align-center
                        justify-center
                        ma-0
                        >
                        <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                    </v-layout>
                    </template>
                </v-img>
                <p class="subheading text-center" v-html="n.Title"></p>
                <span class="ma-0 caption attorney-dates  text-center" style="font-family: 'Mv Eamaan XP' !important; font-size: 10px !important;" v-html="n.Body"></span>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    export default {
        props: ['contents']
    }
</script>
<style>
.attorney-dates>p>span {
    font-size: 0.75rem !important;
}
</style>